import { render, staticRenderFns } from "./EditboxForm.vue?vue&type=template&id=242d08bf&scoped=true&"
import script from "./EditboxForm.vue?vue&type=script&lang=js&"
export * from "./EditboxForm.vue?vue&type=script&lang=js&"
import style0 from "./EditboxForm.vue?vue&type=style&index=0&id=242d08bf&prod&lang=css&"
import style1 from "./EditboxForm.vue?vue&type=style&index=1&id=242d08bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d08bf",
  null
  
)

export default component.exports